module.exports = __webpack_public_path__ + "static/media/Baskervald Italic-01.19a5170a.svg";